import { useState } from 'react';
import { useImmigrationInstanceStore } from 'src/stores/ImmigrationInstanceStore';
import { redirectToRemoteCaseDetails, shouldSkipGlobalCaseTransitionModal } from 'src/utils/services/case';
import { ImmigrationInstance } from 'src/utils/constants/common';
import GlobalCaseTransitionModal, {
  GlobalCaseTransitionModalType,
} from 'src/components/GlobalCaseTransitionModal/GlobalCaseTransitionModal';
import RemoteInfoBanner from 'src/components/RemoteInfoBanner/RemoteInfoBanner';

const DESCRIPTIONS = {
  [ImmigrationInstance.BAL]:
    'This case is being managed by immigration teams at Deloitte. You can view more details related to this case on Deloitte GlobalAdvantage.',
  DEFAULT:
    'This case is being managed by immigration teams at BAL. You can view more details related to this case on Cobalt.',
} as const;

interface IRemoteCaseDetailsBanner {
  caseName: string;
  universalCaseId: string;
}

const RemoteCaseDetailsBanner = ({ caseName, universalCaseId }: IRemoteCaseDetailsBanner) => {
  const { immigrationInstance } = useImmigrationInstanceStore();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const description =
    immigrationInstance === ImmigrationInstance.BAL ? DESCRIPTIONS[ImmigrationInstance.BAL] : DESCRIPTIONS.DEFAULT;

  const handleModalOpen = () => {
    shouldSkipGlobalCaseTransitionModal() ? redirectToRemoteCaseDetails(universalCaseId) : setIsModalOpen(true);
  };

  return (
    <>
      <RemoteInfoBanner title={description} buttonInfo={{ text: 'View Case Details', onClick: handleModalOpen }} />
      <GlobalCaseTransitionModal
        isModalOpen={isModalOpen}
        modalType={GlobalCaseTransitionModalType.CASE}
        name={caseName || ''}
        onNavigate={() => redirectToRemoteCaseDetails(universalCaseId)}
        onModalClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default RemoteCaseDetailsBanner;
